// What "Read billed plans from Stripe" tells the admin afterwards. Besides
// how many plans it read, it names what the platform cannot see on its own:
// plans kept live here after Stripe ended them, and Stripe subscriptions still
// charging that nothing here points to (docs/core/architecture/PLAN_OVERRIDES.md).

import type { BilledPricesReport } from '../../types/subscription';

const short = (id: string) => (id.length > 14 ? `${id.slice(0, 14)}…` : id);

export function describeBilledPricesReport(r: BilledPricesReport): string {
  const parts = [
    `Read ${r.checked} Stripe-billed subscriptions: ${r.updated} updated${r.notInStripe.length ? `, ${r.notInStripe.length} not found in Stripe` : ''}.`,
  ];
  if (r.stripeEnded.length) {
    parts.push([
      `Live here, but Stripe ended the subscription it points to (${r.stripeEnded.length}). Billing filter: Stripe ended.`,
      ...r.stripeEnded.map((e) => `• ${e.user_email ?? 'unknown user'} (${short(e.stripe_subscription_id)}, ${e.stripe_status})`),
    ].join('\n'));
  }
  if (r.removedButCharging.length) {
    parts.push([
      `Removed here, but Stripe is still charging (${r.removedButCharging.length}):`,
      ...r.removedButCharging.map((e) => `• ${e.user_email ?? 'unknown user'} (${short(e.stripe_subscription_id)}, ${e.stripe_status})`),
    ].join('\n'));
  }
  if (r.unlinked.length) {
    parts.push([
      `Stripe is charging, but no plan here points to it (${r.unlinked.length}):`,
      ...r.unlinked.map((u) => {
        const who = u.user_email ?? `${u.customer_email ?? u.customer ?? 'unknown customer'}, no user here`;
        return `• ${who} (${short(u.stripe_subscription_id)}, ${u.status})`;
      }),
    ].join('\n'));
  }
  return parts.join('\n\n');
}
